/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div>
    <sign-in v-if="displayMap.showSignIn" v-bind:signInConfig="options.signInConfig"></sign-in>
    <sign-up v-if="displayMap.showSignUp" v-bind:signUpConfig="options.signUpConfig"></sign-up>
    <confirm-sign-up v-if="displayMap.showConfirmSignUp" v-bind:confirmSignUpConfig="options.confirmSignUpConfig" @signUpSuccessAlert="signUpSuccessAlert"></confirm-sign-up>
    <forgot-password v-if="displayMap.showForgotPassword" v-bind:forgotPasswordConfig="options.forgotPasswordConfig"  @passwordChangeSuccessAlert="passwordChangeSuccessAlert"></forgot-password>
    <v-dialog
      v-model="dialog"
      persistent
      :max-width="400"
    >
      <v-card dense flat>
        <v-card-title class="headline">
        </v-card-title>
        <v-card-text>
          {{dialogMessage}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="clickOK()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AmplifyEventBus from './AmplifyEventBus'
import { Auth, I18n } from 'aws-amplify'
const SignIn = () => import('@/views/auth/SignIn.vue')
const SignUp = () => import('@/views/auth/SignUp.vue')
const ConfirmSignUp = () => import('@/views/auth/ConfirmSignUp.vue')
const ForgotPassword = () => import('@/views/auth/ForgotPassword.vue')

function getUser () {
  return Auth.currentAuthenticatedUser().then((user) => {
    if (!user) {
      return null
    }
    return user
  }).catch(e => new Error(e))
}

export default {
  name: 'HCAuthenticator',
  props: ['authConfig'],
  components: {
    SignIn,
    SignUp,
    ConfirmSignUp,
    ForgotPassword
  },
  data () {
    return {
      user: {
        username: ''
      },
      displayMap: {},
      error: '',
      logger: {},
      dialog: false,
      resolve: null,
      reject: null,
      dialogMessage: null
    }
  },
  computed: {
    options () {
      const defaults = {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        forgotPasswordConfig: {}
      }
      return Object.assign(defaults, this.authConfig || {})
    }
  },
  async mounted () {
    if (!this.$store.getters.getEmailVerified) {
      this.displayMap = this.updateDisplayMap('signedOut')
    }
    AmplifyEventBus.$on('localUser', user => {
      this.user = user
      this.options.signInConfig.username = this.user.username
      this.options.confirmSignUpConfig.username = this.user.username
    })
    AmplifyEventBus.$on('authState', data => {
      this.displayMap = this.updateDisplayMap(data)
    })
    getUser()
      .then((val) => {
        if (val instanceof Error) {
          this.displayMap = this.updateDisplayMap('signedOut')
        } else {
          this.user = val
          if (this.$store.getters.getEmailVerified === true) {
            // IE判定
            const userAgent = window.navigator.userAgent.toUpperCase()
            if (userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1) {
              // IEではない
              this.$router.push('course')
            } else {
              // IEを利用
              this.$router.push('manage')
            }
          }
        }
      })
      .catch(e => this.setError(e))
  },
  methods: {
    updateDisplayMap (state) {
      return {
        showSignIn: state === 'signedOut' || state === 'signIn',
        showSignUp: state === 'signUp',
        showConfirmSignUp: state === 'confirmSignUp',
        showForgotPassword: state === 'forgotPassword'
      }
    },
    setError (e) {
      this.error = I18n.get(e.message || e)
      this.$log.debug(this.error)
    },
    signUpSuccessAlert () {
      this.open('ユーザー登録が完了しました。「登録済みの方」よりログインしてください。')
    },
    passwordChangeSuccessAlert () {
      this.open('パスワード変更が完了しました。「登録済みの方」よりログインしてください。')
    },
    open (message) {
      this.dialog = true
      this.dialogMessage = message
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    clickOK () {
      this.resolve(true)
      this.dialog = false
    }
  }
}
</script>
